(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["honeypot-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.honeypot-announcement').forEach((section) => {
      if (section.dataset.bound === 'true') return;
      section.dataset.bound = 'true';

      const messages = Array.from(section.querySelectorAll('.honeypot-announcement__message'));
      const dots = Array.from(section.querySelectorAll('.honeypot-announcement__dot'));
      if (messages.length < 2) return;

      const intervalMs = Number(section.dataset.rotationMs) || 4000;
      let activeIndex = messages.findIndex((message) => message.classList.contains('is-active'));
      let timer = null;

      const setActive = (nextIndex) => {
        activeIndex = nextIndex;
        messages.forEach((message, index) => {
          message.classList.toggle('is-active', index === nextIndex);
        });
        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === nextIndex);
        });
      };

      const restart = () => {
        if (timer) window.clearInterval(timer);
        timer = window.setInterval(() => {
          setActive((activeIndex + 1) % messages.length);
        }, intervalMs);
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          setActive(Number(dot.dataset.index) || 0);
          restart();
        });
      });

      restart();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["honeypot-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.honeypot-hero-shell').forEach((section) => {
      if (section.dataset.bound === 'true') return;
      section.dataset.bound = 'true';

      const slides = Array.from(section.querySelectorAll('.honeypot-hero__slide'));
      if (!slides.length) return;

      const startIndex = Number(section.dataset.startIndex) || 0;
      const autoplayMs = Number(section.dataset.autoplayMs) || 4500;
      let current = startIndex >= 0 && startIndex < slides.length ? startIndex : 0;
      let timer = null;

      const setActive = (index) => {
        current = index;
        slides.forEach((slide, slideIndex) => {
          slide.classList.toggle('is-active', slideIndex === index);
        });
      };

      const restart = () => {
        if (timer) window.clearInterval(timer);
        timer = window.setInterval(() => {
          setActive((current + 1) % slides.length);
        }, autoplayMs);
      };

      setActive(current);
      if (slides.length > 1) restart();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["honeypot-home-journal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.honeypot-journal').forEach((section) => {
      if (section.dataset.bound === 'true') return;
      section.dataset.bound = 'true';

      const tabs = Array.from(section.querySelectorAll('.honeypot-journal__tab'));
      const panels = Array.from(section.querySelectorAll('.honeypot-journal__panel'));
      if (!tabs.length || !panels.length) return;

      const setActive = (targetId) => {
        tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.target === targetId));
        panels.forEach((panel) => panel.classList.toggle('is-active', panel.id === targetId));
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => setActive(tab.dataset.target));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["honeypot-home-period-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.honeypot-period-finder').forEach((section) => {
      if (section.dataset.bound === 'true') return;
      section.dataset.bound = 'true';

      const select = section.querySelector('[data-period-select]');
      const cards = Array.from(section.querySelectorAll('.honeypot-period-finder__card'));
      if (!select || !cards.length) return;

      const setActive = (index) => {
        cards.forEach((card) => {
          card.classList.toggle('is-active', Number(card.dataset.index) === index);
        });
      };

      select.addEventListener('change', () => setActive(Number(select.value) || 0));
      setActive(0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["honeypot-site-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.__honeypotCartBridgeBound) {
      window.__honeypotCartBridgeBound = true;

      const routeRoot = window.Shopify?.routes?.root || '/';
      const route = (path) => `${routeRoot.endsWith('/') ? routeRoot : `${routeRoot}/`}${path}`;
      const countSelector = '[data-honeypot-cart-count]';
      const linkSelector = '[data-honeypot-cart-link]';

      const renderCount = (value) => {
        const count = Math.max(0, Number(value) || 0);

        document.querySelectorAll(countSelector).forEach((node) => {
          node.textContent = count > 99 ? '99+' : String(count);
          node.hidden = count === 0;
        });

        document.querySelectorAll(linkSelector).forEach((node) => {
          node.setAttribute('aria-label', count > 0 ? `Cart (${count} ${count === 1 ? 'item' : 'items'})` : 'Cart');
        });
      };

      const currentCount = () => {
        const node = document.querySelector(countSelector);
        return Math.max(0, Number(node?.textContent) || 0);
      };

      const readCart = async () => {
        const response = await fetch(route('cart.js'), {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });

        if (!response.ok) throw new Error(`Cart read failed (${response.status})`);
        const cart = await response.json();
        renderCount(cart.item_count);
        return cart;
      };

      document.addEventListener('cart:update', (event) => {
        const count = Number(event.detail?.resource?.item_count);
        if (Number.isFinite(count)) {
          renderCount(count);
          return;
        }

        readCart().catch(() => {});
      });

      document.addEventListener('submit', async (event) => {
        const form = event.target instanceof HTMLFormElement ? event.target : null;
        if (!form || event.defaultPrevented || form.dataset.cartBridgeSubmitting === 'true') return;

        const action = new URL(form.action, window.location.href);
        if (!action.pathname.endsWith('/cart/add')) return;

        event.preventDefault();
        form.dataset.cartBridgeSubmitting = 'true';

        const submitButton = event.submitter instanceof HTMLButtonElement ? event.submitter : null;
        const wasDisabled = submitButton?.disabled || false;
        const formData = new FormData(form);
        const quantity = Math.max(1, Number(formData.get('quantity')) || 1);
        let itemAdded = false;

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
        }

        try {
          const response = await fetch(route('cart/add.js'), {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
            credentials: 'same-origin',
          });

          if (!response.ok) throw new Error(`Add to cart failed (${response.status})`);
          itemAdded = true;

          let cart;
          try {
            cart = await readCart();
          } catch {
            renderCount(currentCount() + quantity);
          }

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                data: {
                  source: 'honeypot-cart-bridge',
                  itemCount: cart?.item_count ?? quantity,
                },
              },
            }),
          );

          submitButton?.setAttribute('data-added', 'true');
          window.setTimeout(() => submitButton?.removeAttribute('data-added'), 900);
        } catch {
          if (!itemAdded) {
            HTMLFormElement.prototype.submit.call(form);
            return;
          }
        } finally {
          delete form.dataset.cartBridgeSubmitting;
          if (submitButton) {
            submitButton.disabled = wasDisabled;
            submitButton.removeAttribute('aria-busy');
          }
        }
      });

      window.addEventListener('pageshow', () => {
        readCart().catch(() => {});
      });
    }

    document.querySelectorAll('.honeypot-header-shell').forEach((section) => {
      if (section.dataset.bound === 'true') return;
      section.dataset.bound = 'true';

      const drawer = section.querySelector('.honeypot-mobile-drawer');
      const button = section.querySelector('.honeypot-header__menu-button');
      if (!drawer || !button) return;

      const closeTargets = drawer.querySelectorAll('[data-close]');

      const setOpen = (isOpen) => {
        drawer.hidden = !isOpen;
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        document.documentElement.classList.toggle('honeypot-drawer-open', isOpen);
        document.body.classList.toggle('honeypot-drawer-open', isOpen);
      };

      button.addEventListener('click', () => setOpen(drawer.hidden));
      closeTargets.forEach((target) => target.addEventListener('click', () => setOpen(false)));
      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') setOpen(false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
